import firebase from 'firebase/app';
import 'firebase/storage';

export const getStorageItemUrl = {
    methods: {
        getStorageItemUrl(path) {
            return firebase.storage().ref().child(path).getDownloadURL();
        }
    }
}
